import { StyledSelectIntWoController } from "@/components/styled/StyledSelectIntWoController";
import { MONTHS_OPTIONS } from "@/constants/options/months.option";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

type MonthSelectProps = {
  onChange: (month?: number[]) => void;
  placeholder?: string;
  className?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  isSearchable?: boolean;
  isMulti?: boolean;
  defaultValue?: number;
};

export const StyledMonthSelect = ({
  onChange,
  placeholder,
  className = "",
  isClearable = true,
  isDisabled = false,
  isSearchable = true,
  isMulti = false,
  defaultValue,
}: MonthSelectProps) => {
  const { t } = useTranslation("shared");
  const handleChange = (e: any) => {
    if (isMulti) {
      // Multiple selection
      if (e && Array.isArray(e)) {
        onChange(e.map((option) => option.value));
      } else {
        onChange(undefined);
      }
    } else {
      // Single selection - return as array for consistency
      onChange(e?.value ? [e.value] : undefined);
    }
  };

  const defaultOption = MONTHS_OPTIONS.find((option) => option.value === defaultValue);

  const selectDefaultValue = defaultOption
    ? isMulti
      ? [defaultOption]
      : defaultOption
    : undefined;

  return (
    <StyledSelectIntWoController
      isClearable={isClearable}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      className={clsx("min-w-[150px]", className)}
      onChange={handleChange}
      options={MONTHS_OPTIONS}
      placeholder={placeholder ?? t("monthSelect.placeholder")}
      defaultValue={selectDefaultValue}
      isMulti={isMulti}
    />
  );
};
